export const ShipConfirmSource = {
  ebs: 'EBS',
  argen: 'Argen',
} as const

export type ShipConfirmSource = (typeof ShipConfirmSource)[keyof typeof ShipConfirmSource]
